import { useContext } from 'react'
import FieldMetadataContext from '../FieldMetadataContext'
import { FieldMetadata } from '../fieldMetadata.types'

export function useFieldMetadata<T = string | number>(path: string) {
  const metadata = useContext(FieldMetadataContext) as Record<
    string,
    FieldMetadata<T>
  >

  return metadata[path] || {}
}
